module.exports = __webpack_public_path__ + "media/images/checkout/rupay-193e63a3c9a8f567737fc0895ff0495f.png";